import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core'
import {NgOptimizedImage} from '@angular/common'
import {ProgressiveDisclosureBoxComponent} from '../../../../../craft/progressive-disclosure-box/progressive-disclosure-box.component'
import {FormsModule} from '../../../../../craft/forms/forms.module'
import {SelectModule} from '../../../../../craft/forms/select/select.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {faLock} from '@fortawesome/pro-solid-svg-icons/faLock'
import {faShieldCheck} from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import {TranslocoModule} from '@ngneat/transloco'
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms'
import {LinkService} from '../../../../../core/i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../routing/public.routes'
import {RouterLink} from '@angular/router'
import {DirectivesModule} from '../../../../directives/directives.module'
import {JobRequestRepository} from '../../../../../pages/public/job-request-page/job-request.repository'
import {Logger} from '../../../../../core/logging/logger.types'

@Component({
  selector: 'bgo-start-job-progressive-disclosure-box',
  templateUrl: './start-job-progressive-disclosure-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgOptimizedImage,
    ProgressiveDisclosureBoxComponent,
    FormsModule,
    SelectModule,
    FontAwesomeModule,
    TranslocoModule,
    ReactiveFormsModule,
    RouterLink,
    DirectivesModule,
  ],
})
export class StartJobProgressiveDisclosureBoxComponent implements OnInit {
  @Input() offering!: {id: string; title: string}
  @Input() intentions: {label: string; slug: string}[] = []
  readonly headingIcon = faShieldCheck
  readonly lockIcon = faLock
  readonly intentionsControl = new FormControl(undefined)
  readonly expectationsControl = new FormControl(undefined, [Validators.required])

  readonly expectations: {key: string; valueTranslationKey: string}[] = [
    {key: 'estimation', valueTranslationKey: 'startJobProgressiveDisclosure.expectations.estimation'},
    {key: 'consulting', valueTranslationKey: 'startJobProgressiveDisclosure.expectations.consulting'},
    {key: 'offer', valueTranslationKey: 'startJobProgressiveDisclosure.expectations.offer'},
    {key: 'execution', valueTranslationKey: 'startJobProgressiveDisclosure.expectations.execution'},
  ]

  intentionItems: {key: string; value: string}[] = []

  readonly happinessGuaranteeLink = this.linkService.happinessGuaranteePagePath

  readonly form: FormGroup = new FormGroup({
    intentions: this.intentionsControl,
    expectations: this.expectationsControl,
  })

  constructor(
    private readonly linkService: LinkService,
    private readonly repository: JobRequestRepository,
    private readonly logger: Logger,
  ) {}

  ngOnInit(): void {
    this.intentionItems = this.intentions.map(i => ({key: i.slug, value: i.label}))
  }

  startRequest() {
    if (!this.form.valid) {
      this.form.markAllAsTouched()
      return
    }

    const intentionSlug = this.intentionsControl.value
    if (intentionSlug) {
      this.repository.setIntentionSlug(intentionSlug)
    }

    const selectedExpectation = this.expectationsControl.value
    if (!selectedExpectation) {
      this.logger.error('Expected expectations to be selected.')
      return
    }
    this.repository.storeClientExpectationState({
      consulting: false,
      offer: false,
      estimation: false,
      execution: false,
      [selectedExpectation]: true,
    })

    return this.linkService.navigateTo(PUBLIC_ROUTES.JOB_REQUEST_DETAIL, {
      routeParams: {offeringId: this.offering.id},
    })
  }
}
